import React from 'react'
import Icon from './Icon'

const CircleInfo = props => {
  return <Icon icon="fas fa-solid fa-info-circle" {...props} />
}

export default CircleInfo
